import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Miscellaneous|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryMiscellaneous';
export type SPCandidateHistoryMiscellaneousLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`;

export const spCandidateHistoryMiscellaneousLocs: LocDefs<SPCandidateHistoryMiscellaneousLocNames> =
	{
		SPCandidateHistoryMiscellaneousTitlePage: {
			defaultValue: 'Miscellaneous',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.Title.PageSectionTitle',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousTitleTab: {
			defaultValue: 'Miscellaneous',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.Title.Tab',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelActiveDate: {
			defaultValue: 'Active Date',
			description: 'Column heading for: Active Date.',
			displayPath: `${pathStart}Active Date`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.ActiveDate',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelExpireDate: {
			defaultValue: 'Expire Date',
			description: 'Column heading for: Expire Date.',
			displayPath: `${pathStart}Expire Date`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.ExpireDate',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelUpdated: {
			defaultValue: 'Updated',
			description: 'Column heading for: Updated.',
			displayPath: `${pathStart}Updated`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.Updated',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelReviewStatus: {
			defaultValue: 'Review Status',
			description: 'Column heading for: Review Status.',
			displayPath: `${pathStart}Review Status`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.ReviewStatus',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelInvalid: {
			defaultValue: 'Invalid',
			description: 'Column heading for: Invalid.',
			displayPath: `${pathStart}Invalid`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.Invalid',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelDataProvider: {
			defaultValue: 'Data Provider',
			description: 'Column heading for: Data Provider.',
			displayPath: `${pathStart}Data Provider`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.DataProvider',
			...sharedProperties,
		},
		SPCandidateHistoryMiscellaneousLabelDocumentation: {
			defaultValue: 'Documentation',
			description: 'Column heading for: Documentation.',
			displayPath: `${pathStart}Documentation`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Miscellaneous.ColumnHeading.Documentation',
			...sharedProperties,
		},
	};

export type SPCandidateHistoryMiscellaneousLocType =
	LocMap<SPCandidateHistoryMiscellaneousLocNames>;
